<script setup lang="ts">
   const props = defineProps<{
      label?: string;
   }>();

   function scrollToNextSection(event: Event) {
      const heroEl = (event.target as HTMLElement).closest('[data-scroll-root]');
      heroEl?.nextElementSibling?.scrollIntoView({ behavior: 'smooth' });
   }
</script>

<template>
   <button
      class="animate-subtle-bounce absolute bottom-6 left-1/2 z-20 flex -translate-x-1/2 cursor-pointer items-center gap-1 rounded-full bg-white/20 px-4 py-2 backdrop-blur-sm transition-opacity hover:bg-white/30"
      aria-label="Scroll down"
      @click="scrollToNextSection">
      <span class="text-xs font-medium tracking-wide text-white">
         {{ props.label || 'More Info' }}
      </span>
      <i class="pi pi-chevron-down text-sm text-white"></i>
   </button>
</template>

<style scoped>
   @keyframes subtle-bounce {
      0%,
      100% {
         transform: translateX(-50%) translateY(0);
      }
      50% {
         transform: translateX(-50%) translateY(-6px);
      }
   }
   .animate-subtle-bounce {
      animation: subtle-bounce 2.5s ease-in-out infinite;
   }
</style>
